import { topicsData } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            全网动漫爱好者正在关注的热门内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${colorMap[topic.color]}`}>
                <i className="ri-hashtag text-xl"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                    {topic.tag}
                  </h3>
                  <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {topic.heat}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 mt-1 truncate">
                  {topic.desc}
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}